import { Component } from '@angular/core';

@Component({
  selector: 'app-branding-header-bar',
  templateUrl: './branding-header-bar.component.html',
  styleUrls: ['./branding-header-bar.component.scss']
  })
export class BrandingHeaderbar {

  constructor() { }
}
